import { type FC } from 'react';
import { CardSelect, IconButton } from '@cencosud-cencommerce/paris-uikit';
import classNames from 'classnames';

import type { Address } from '@/modules/address/domain/Address';
import { useLabeledAddress } from '@/sections/address/hooks/useLabeledAddress';

interface Props {
  address: Address;
  checked: boolean;
  onClick: (addressId: Address['id']) => void;
  onEdit: (address: Address) => void;
}

const AddressItem: FC<Props> = ({ address, checked, onClick, onEdit }) => {
  const labeledAddress = useLabeledAddress(address);

  return (
    <CardSelect
      title={address.alias as string}
      description1={labeledAddress || ''}
      className="co-group co-transition-all co-duration-200"
      radioButton={{
        id: `address-${address.id}`,
        name: 'addresses',
        value: address.id,
        checked,
        onChange: () => onClick(address.id)
      }}
      ctaComponent={
        <IconButton
          feedback="neutral"
          icon="edit"
          className={classNames('co-opacity-0', {
            'group-hover:co-opacity-100': true
          })}
          onClick={(e) => {
            e.stopPropagation();
            onEdit(address);
          }}
        />
      }
      onClick={() => onClick(address.id)}
    />
  );
};

export default AddressItem;
